import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNext = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	id: "next",
	"data-name": "next",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "-6 -6 36 36",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("line", {
			className: "plan2plate-icon white-stroke thick-stroke",
			x1: 23.017193,
			y1: 12,
			x2: -1.0171943,
			y2: 12,
			id: "line1"
		}),
		/* @__PURE__ */ _jsx("polyline", {
			className: "plan2plate-icon white-stroke thick-stroke",
			points: "13.86 4.36 21.5 12 13.86 19.64",
			id: "polyline1",
			transform: "matrix(1.1444947,0,0,1.1444947,-1.5894416,-1.7339363)"
		})
	]
});
const ForwardRef = forwardRef(SvgNext);
export default ForwardRef;
